// url參數
let scriptId = document.getElementById("fundAssertRatioScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "IV16";

// 數字格式化
function NumFormatter(num, decimal) {
  this.value =
    num !== null && num !== undefined
      ? num.toLocaleString(undefined, {
          minimumFractionDigits: decimal,
          maximumFractionDigits: decimal,
        })
      : "--";

  this.addPercent = function () {
    this.value =
      num !== null && num !== undefined ? `${this.value}%` : this.value;
    return this;
  };
}

function numHandler(num, decimal = 2) {
  return new NumFormatter(num, decimal);
}

function formatPercent(num, decimal) {
  return numHandler(num, decimal).addPercent().value; // 12.55%
}

function renderAssertDataBlock(data) {
  const assertRatioContainer = document.getElementById(
    "assert-ratio-container"
  );

  const assertRatioItems = data.map(
    (item) => `
      <div style="margin-bottom: 1rem; position: relative; color: #333333">
        <div style="width: 85%; height: 24px; background: #F5F5F5; position: relative; border-radius: 4px;">
          <div style="width: ${
            item.value * 100
          }%; height: 24px; background: #C2DEFD; border-radius: 4px; position: absolute; left: 0; top: 0;"></div>
          <div style="font-size: 16px; position: absolute; left:12px; top:4px; line-height: 1">${
            item.name
          }</div>
        </div>
        <div style="font-size: 16px; position: absolute; right:0px; top:4px; line-height: 1">${formatPercent(
          item.value * 100
        )}</div>
      </div>
    `
  );

  assertRatioContainer.innerHTML = assertRatioItems.join("");
}

let isAssertExpanded = false;
/* eslint-disable-next-line no-unused-vars */
function assertCheckMore() {
  isAssertExpanded = !isAssertExpanded;
  const displayedData = isAssertExpanded
    ? assertRatio.data // 展示全部數據
    : assertRatio.data.slice(0, 5); // 只展示前 5 筆

  // 重新渲染數據
  renderAssertDataBlock(displayedData);
  // 更新按鈕文字
  const assertCheckMoreButton = document.getElementById("assertCheckMore");
  assertCheckMoreButton.querySelector("div:first-child").textContent =
    isAssertExpanded ? "收合" : "看更多";
  // 切換箭頭旋轉效果
  const arrow = document.getElementById("assertCheckMoreArrow");
  arrow.style.transform = isAssertExpanded ? "rotate(180deg)" : "rotate(0deg)";
}

let assertRatio;
function loadScript() {
  const targetElement = document.getElementById("fundAssertRatioScript");

  let url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/portfolio`;
  fetch(url)
    .then((response) => {
      // 檢查回應是否成功
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json(); // 將回應轉換為 JSON 格式
    })
    .then((data) => {
      //建立基本資料區域
      assertRatio = data.assertAllocation;
      const assertRatioInfo = document.createElement("div");

      //渲染基本資料
      if (assertRatio.data) {
        const showMoreButton = assertRatio.data.length > 5 ? `
          <div id="assertCheckMore" style="display: flex; justify-content: center; align-items: center; cursor: pointer; font-size: 14px; margin-top: 8px; width: 100%; color: #666666; font-weight: 500;">
              <div style="margin-right: 2px">看更多</div>
              <div id="assertCheckMoreArrow" style="width: 14px; transition: transform 0.3s;">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
              </div>
          </div>
        ` : '';

        assertRatioInfo.innerHTML = `
        <div>
            <div style="color: #333333; font-weight: 500; font-size: 18px; margin-bottom: 8px;">
                資產分布
                <span style="font-size: 14px; color: #999999">${
                  assertRatio.yearMonth
                } 更新</span>
            </div>

            <div id="assert-ratio-container">
                
            </div>

             ${showMoreButton}
        </div>
    `;
        
        targetElement.innerHTML = '';
        targetElement.appendChild(assertRatioInfo);
        renderAssertDataBlock(assertRatio.data.slice(0, 5));
        const assertCheckMoreButton = document.getElementById("assertCheckMore");
        if (assertCheckMoreButton) {
          assertCheckMoreButton.addEventListener('click', assertCheckMore)
        }
      } else {
        let noData = document.createElement("div");

        noData.innerHTML = `
        <div>
          <div style="color: #333333; font-weight: 500; font-size: 18px; margin-bottom: 8px;">
            資產分布
          </div>
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 184px;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="54" height="54"><path fill="#EBEBEB" d="M567.9 243.9L462.3 85.4A48 48 0 0 0 422.3 64H153.7a48 48 0 0 0 -39.9 21.4L8.1 243.9A48 48 0 0 0 0 270.5V400c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V270.5a48 48 0 0 0 -8.1-26.6zM162.3 128h251.5l85.3 128H376l-32 64H232l-32-64H76.9l85.3-128z"/></svg>
            <div style="color: #999999; font-size: 14px; margin-top: 8px; width: 100%; font-weight: 500; text-align: center">暫無資料</div>
          </div>
        </div>
        `;

        targetElement.innerHTML = '';
        targetElement.appendChild(assertRatioInfo);
        assertRatioInfo.appendChild(noData);
      }
    })
    .catch((error) => {
      // 捕獲並處理錯誤
      console.error("發生錯誤:", error);
    });
}

loadScript();
